import { ENVIRONMENT } from "src/js/util/environment";

type BillingWrapperProps = {
  children: React.ReactNode;
  flow?: "upgrade" | "cancel";
};
export const BillingWrapper = ({ children, flow = undefined }: BillingWrapperProps) => {
  const handleRedirect = () => {
    window.location.href = `${ENVIRONMENT.ACCOUNTS_SERVICE_PRIVATE_API_URL}/customer-portal${
      flow ? "?flow=" + flow : ""
    }`;
  };

  return <div onClick={handleRedirect}>{children}</div>;
};
